export default {
  base_url: '/api/illustrator/profile/portfolio/image-set/image-sets',
  portfolio_images_url: '/api/illustrator/profile/portfolio/images',

  store(form) {
    return form.post(this.base_url);
  },

  fetch(id, relationships) {
    return axios.get(`${this.base_url}/${id}`, {
      params: {
        relationships
      }
    }).then(response => response.data);
  },

  update(form, id) {
    return form.put(`${this.base_url}/${id}`);
  },

  createCropImage(data) {
    return axios.post(this.create_cropped_image_set_image_url, data).then(response => response.data);
  },

  updateWithAttachment(id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`${this.base_url}/${id}/update-with-attachment`, data).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error);
      });
    });
  },


};